import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Auth } from '../../services/auth';
import { environment } from '../../../environments/environment';
import { Sso } from '../../services/sso';
import { WebStorage } from '../../services/web-storage';
import { Common } from '../../services/common';

@Component({
  selector: 'app-login',
  imports: [CommonModule],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit{
  constructor(private authService: Auth, private router: Router, private readonly ssoService: Sso,
    private readonly webStorageService: WebStorage, private cd: ChangeDetectorRef, private commonService: Common
  ) { }

  loading: boolean = false;
  loadingMessage: string = 'Authenticating...';
  loggedout: boolean = false;
  loginFeatureEnabled: boolean = environment.loginFeature;

  async ngOnInit() {
    this.loading = true;
    this.loadingMessage = this.authService.getLogoutProcess() ? 'Logging out...' : 'Authenticating...';
    if (['prod', 'uat'].includes(environment.name.toLowerCase())) {
      this.ssoService.$user.subscribe((usr: any) => {
        console.log('Login-Component: Subscribed to SSO user observable' + JSON.stringify(usr));
        if (usr != null) {
          const roles = usr.roles.length ? usr.roles.map((role: string) => role.toLowerCase()) : [];
          if (roles.length > 1) {
            this.router.navigate(['/role-select']);
          } else {
            this.navigateByRole(usr.role);
          }
          this.cd.detectChanges();
        }
      });
      await this.processSSOLogin();
    } else {
      this.processGoogleLogin();
    }
  }

  async processSSOLogin() {
    let user = this.webStorageService.retrieveItem('cu');
    if (user) {
      console.log('User found in session storage, emitting through SSO service');
      this.ssoService.$user.next(user);
      this.cd.detectChanges();
    } else {
      console.log('No user found in session storage');
      if (this.authService.getLogoutProcess()) {
        this.doLogoutProcess();
      } else {
        if (environment.loginFeature) {
          console.log('Initializing SSO service...');
          await this.ssoService.initialize();
          this.ssoService.loginRedirect();
          let user = this.webStorageService.retrieveItem('cu');
          if (user) {
            console.log('Emitting user through SSO service');
            this.ssoService.$user.next(user);
            this.cd.detectChanges();
          }
        } else {
          console.log('No user found and direct entry is disabled. Redirecting to no-entry page...');
          this.router.navigate(['/no-entry']);
        }
      }
    }
  }

  processGoogleLogin() {
    if (this.authService.getAccessToken() != null && this.authService.getAccessToken() != undefined && this.authService.getAccessToken() != '') {
      console.log('User already logged in. Redirecting to home...');
      let navigateTo = this.commonService.getNavigateByRole(this.authService.getUserDetails()?.role || '');
      this.router.navigate([navigateTo]);
    } else {
      if (this.authService.getLogoutProcess()) {
        this.doLogoutProcess();
      } else {
        this.login();
      }
    }
  }

  navigateByRole(role: string): void {
    const path = this.commonService.getNavigateByRole(role);
    this.router.navigate([path]);
  }

  doLogoutProcess() {
    console.log('Logout process completed. Redirecting to login page...');
    this.authService.setLogoutProcess(false);
    this.loading = false;
    this.loggedout = true;
  }

  login() {
    console.log('Initiating login process...');
    if (['prod', 'uat'].includes(environment.name.toLowerCase())) {
      // this.ssoService.loginRedirect();
      window.location.href = '';
    } else {
      this.authService.initiateLogin();
    }
  }
}
